import {Component} from 'react';
import {
    CCText,
    Text,
    TouchableOpacity,
    View
} from '../react-native-components-in-react/react-native-components-in-react';

const disabledButtonStyle = {
    backgroundColor: '#CCCCCC',
    boxShadow: 'none'
}

const disabledTextStyle = {
    color: 'gray'
}

export default class DefaultButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let disabledStyle = {};

        if (this.props.disabled) {
            disabledStyle = { opacity: 0.5 }
        }

        return <TouchableOpacity
            onPress={() => {
                if (!this.props.disabled && this.props.onPress)
                    this.props.onPress();
            }}
            to={this.props.to}
            className={this.props.className}
        >
            <View
                style={{
                    padding: '6px 8px',
                    borderRadius: 6,
                    backgroundColor: 'white',
                    flexDirection: 'row',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
                    ...this.props.style,
                    ...disabledStyle
                }}>
                {this.props.icon ?
                    this.props.icon
                    :
                    null}
                {this.props.icon && this.props.text ?
                    <View style={{ width: 5 }}>
                    </View>
                    :
                    null}
                <Text style={{ fontWeight: 'bold', color: '#404040', textAlign: 'center', ...this.props.textStyle }}>
                    {this.props.text}
                </Text>
            </View>
        </TouchableOpacity>;
    }

}

export class BorderlessButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let disabledStyle = {};

        if (this.props.disabled) {
            disabledStyle = { opacity: 0.5 }
        }

        return <TouchableOpacity
            className={'clickable react-button ' + this.props.className}
            onPress={(event) => {
                if (!this.props.disabled && this.props.onPress)
                    this.props.onPress(event);
            }}
            to={this.props.to}
        >
            <View
                style={{
                    padding: '6px 8px',
                    flexDirection: 'row',
                    justifyContent: this.props.alignText ? this.props.alignText : 'center',
                    ...this.props.style,
                    ...disabledStyle
                }}>
                {this.props.icon ?
                    this.props.icon
                    :
                    null}
                {this.props.icon && this.props.text ?
                    <View style={{ width: 5 }}>
                    </View>
                    :
                    null}
                <Text style={{ color: '#404040', textAlign: 'center', ...this.props.textStyle }}>
                    {this.props.text}
                </Text>
            </View>
        </TouchableOpacity>;
    }

}

export class DarkButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let disabledStyle = {};

        if (this.props.disabled) {
            disabledStyle = { opacity: 0.5 }
        }

        return <TouchableOpacity
            onPress={() => {
                if (!this.props.disabled && this.props.onPress)
                    this.props.onPress();
            }}
            to={this.props.to}
        >
            <View style={{
                backgroundColor: '#404040',
                padding: '6px 8px',
                borderRadius: 6,
                flexDirection: 'row',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
                ...this.props.style,
                ...disabledStyle
            }}>
                {this.props.icon ?
                    this.props.icon
                    :
                    null}
                {this.props.icon && this.props.text ?
                    <View style={{ width: 5 }}>
                    </View>
                    :
                    null}
                <Text style={{ width: '100%', color: 'white', textAlign: 'center', ...this.props.textStyle }}>
                    {this.props.text}
                </Text>
            </View>
        </TouchableOpacity>;
    }

}

export class ThemeButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let disabledStyle = {};
        let textStyle = {};

        if (this.props.disabled) {
            disabledStyle = disabledButtonStyle
            textStyle = disabledTextStyle
        }

        return <TouchableOpacity
            onPress={() => {
                if (!this.props.disabled && this.props.onPress)
                    this.props.onPress();
            }}
            to={this.props.to}
        >
            <View style={{
                backgroundColor: '#f05423',
                padding: '6px 8px',
                borderRadius: 6,
                flexDirection: 'row',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
                ...this.props.style,
                ...disabledStyle
            }}>
                {this.props.icon ?
                    this.props.icon
                    :
                    null}
                {this.props.icon && this.props.text ?
                    <View style={{ width: 5 }}>
                    </View>
                    :
                    null}
                <Text style={{ width: '100%', color: 'white', textAlign: 'center', ...this.props.textStyle, ...textStyle }}>
                    {this.props.text}
                </Text>
            </View>
        </TouchableOpacity>;
    }

}

export class TagButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let disabledStyle = {};

        if (this.props.disabled) {
            disabledStyle = { opacity: 0.5 }
        }

        return <TouchableOpacity
            className={'clickable react-button ' + this.props.className}
            onPress={() => {
                if (!this.props.disabled && this.props.onPress)
                    this.props.onPress();
            }}
            to={this.props.to}
        >
            <View style={{
                padding: '3px 10px',
                borderRadius: '25px',
                backgroundColor: '#404040',
                ...this.props.style,
                ...disabledStyle
            }}>
                <CCText className={"ws-nowrap"} style={{
                    fontSize: "1.1rem",
                    color: 'white',
                    ...this.props.textStyle
                }}>
                    {this.props.text}
                </CCText>
            </View>
        </TouchableOpacity>;
    }

}

export class QuantityPicker extends Component {

    constructor(props) {
        super(props);

        this.state = {
            quantity: props.quantity
        }
    }

    render() {
        let disabledMinusStyle = {};

        if (this.state.quantity == 1) {
            disabledMinusStyle = { opacity: 0.5 }
        }


        return <View style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            ...this.props.style
        }}>
            <TouchableOpacity
                onPress={() => {
                    if(this.state.quantity == 1){
                        return;
                    }

                    const quantity = this.state.quantity - 1;

                    this.setState({
                        quantity: quantity
                    });

                    this.props.onChange(quantity);
                }}
            >
                <Text style={{
                    color: '#404040',
                    borderBottomLeftRadius: 7,
                    borderTopLeftRadius: 7,
                    backgroundColor: '#DDDDDD',
                    padding: 13,
                    paddingTop: 2,
                    paddingBottom: 2,
                    ...disabledMinusStyle
                }}>
                    -
                </Text>
            </TouchableOpacity>
            <Text style={{
                color: '#404040',
                backgroundColor: '#DDDDDD',
                padding: 13,
                paddingTop: 7,
                paddingBottom: 3,
            }}>
                {this.state.quantity}
            </Text>
            <TouchableOpacity
                onPress={() => {
                    const quantity = this.state.quantity + 1;

                    this.setState({
                        quantity: quantity
                    });

                    this.props.onChange(quantity);
                }}
            >
                <Text style={{
                    color: '#404040',
                    borderBottomRightRadius: 7,
                    borderTopRightRadius: 7,
                    backgroundColor: '#DDDDDD',
                    padding: 13,
                    paddingTop: 2,
                    paddingBottom: 2,
                }}>
                    +
                </Text>
            </TouchableOpacity>
        </View>;
    }
}

export class FloatingButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (<TouchableOpacity
            onPress={() => {
                if (!this.props.disabled)
                    this.props.onPress();
            }}
        >
            <View style={{ position: 'fixed', right: 25, bottom: 50, borderRadius: 60 / 2 }}>
                <View style={{
                    width: 60,
                    height: 60,
                    borderRadius: 60 / 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#404040',
                    elevation: 3,
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
                    ...this.props.style,
                }}>
                    {this.props.icon ?
                        this.props.icon
                        :
                        null}
                </View>
            </View>
        </TouchableOpacity>
        );
    }

}



export class ReturnButton extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const style = {...this.props.style}
        const textStyle = {...this.props.textStyle}

        textStyle.color = '#1b6ec2'

        style.padding = '15px 0 0'

        return <BorderlessButton
            className={this.props.className}
            onPress={this.props.onPress}
            to={this.props.to}
            icon={this.props.icon}
            style={style}
            textStyle={textStyle}
            alignText={'left'}
            text={this.props.text}
        />;
    }

}